import React from "react";
import IptcCodeComboBox from "./iptccodecombobox";
import "./themaline.css";

class ThemaLine extends React.Component
{
    constructor(props)
    {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }


    handleChange(value)
    {
        if (this.props.onChange)
            this.props.onChange(value);
    }


    handleDelete()
    {
        if (this.props.onDelete)
            this.props.onDelete();
    }


    render()
    {
        const confidence =
            this.props.confidence == null
                ? ""
                : Number(this.props.confidence).toFixed(1);

        return (
            <div className="thema-line">

                {/* Image */}
                <div className="thema-line-image">
                    {this.props.img && (
                        <img
                            src={this.props.img}
                            alt=""
                        />
                    )}
                </div>


                {/* Combobox */}
                <div className="thema-line-combobox">
                    <IptcCodeComboBox
                        data={this.props.data}
                        value={this.props.iptcCode}
                        onChange={this.handleChange}
                        iptccodemustset={true}
                        listWidth={450}
                    />
                </div>


                {/* Confidence */}
                <div className="thema-line-confidence">
                    {confidence}
                </div>


                {/* Suppression */}
                <button
                    type="button"
                    className="thema-line-delete"
                    onClick={this.handleDelete}
                    title="Supprimer"
                >
                    ×
                </button>

            </div>
        );
    }
}


export default ThemaLine;